import { useFormikContext } from 'formik'
import { useEffect } from 'react'

export function ScrollToErrorField({ id }: { id: string }) {
  const { isSubmitting, isValid, errors } = useFormikContext()

  useEffect(() => {
    if (isValid) return
    const fieldErrorNames = Object.entries(errors)
    if (fieldErrorNames.length <= 0) return
    const [name, value] = fieldErrorNames[0]

    let selector = ''
    if (typeof value === 'object') {
      selector =
        (value as any).length > 0
          ? `#${id} [id='${name}.0.${
              Object.keys(
                (value as any).find((row: any) => row !== undefined)
              )[0]
            }']`
          : `#${id} [id='${name}.${Object.keys(value as any)[0]}']`
    } else {
      selector = `#${id} [id='${name}']`
    }

    const element = document.querySelector(selector)
    if (!element) return
    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [isSubmitting]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}
